// Saga effects
import { fork, all } from 'redux-saga/effects';
import { watchGetInfoMe, watchGetListVaiTro } from './Auth/Saga';
import { watchFetchDanhMucHuyen, watchFetchDanhMucXa, watchFetchDanhMucById } from './DanhMucDungChung/Saga';
import { watchFetchDataAPI } from './Common/Saga';
import { watchNewNguoiDungs, watchDeleteNguoiDungs } from './User/Saga';

export default function* rootSaga() {
  yield all([
    fork(watchGetInfoMe),
    fork(watchGetListVaiTro),
    fork(watchFetchDanhMucHuyen), // Dùng chung
    fork(watchFetchDanhMucXa),
    fork(watchFetchDanhMucById),
    fork(watchFetchDataAPI),
    fork(watchNewNguoiDungs), // Người dùng
    fork(watchDeleteNguoiDungs)
  ]);
}
